import { createApp } from "vue";
import gettext from "./language";
import Main from "./Main.vue";
import "./registerServiceWorker";
import "./styles/main.scss";
import sentry from "./sentry";
import router from "./router";
import NicePlugin from "vue3-nice-elements";
import CurrencyPlugin from "@/plugins/currency";
import DatePlugin from "@/plugins/date";
import QueryPlugin from "@/plugins/query";
import TokenService from "@/services/token.service";
import { createPinia } from "pinia";
const pinia = createPinia();

// If token exists set header and mount the interceptor
TokenService.readFromCookies();

const app = createApp(Main);
app.use(gettext);
app.use(pinia);
app.use(router);
app.use(NicePlugin, { router, gettext });
app.use(CurrencyPlugin);
app.use(DatePlugin);
app.use(QueryPlugin);
sentry.init(app, router);
app.mount("#app");

export default app;
